"use client";

/**
 * App binding for the brandless @repo/nps cooldown hook: injects this app's
 * server actions, so call sites keep the original zero-arg `useNpsCooldown()`.
 */
import { useNpsCooldown as usePackageNpsCooldown } from "@repo/nps/hooks";
import { setNpsCooldown, setNpsDeferral } from "../actions";

// Module-scope so the injected object is referentially stable across renders.
const actions = { setNpsCooldown, setNpsDeferral };

export function useNpsCooldown() {
  return usePackageNpsCooldown(actions);
}
